module.exports = __webpack_public_path__ + "static/media/Magical Quest 3 - No Letterbox hack.d50a2d7a.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Magical Quest 3 - No Letterbox hack.zip
// module id = 45
// module chunks = 0